import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../App.css';

const Evaluacion = () => {
  const { tecnico, ticket, tipo_servicio, id_sql } = useParams();

  const [valorEvaluacion, setValorEvaluacion] = useState(0);
  const [likeSeleccionado, setLikeSeleccionado] = useState(false);
  const [dislikeSeleccionado, setDislikeSeleccionado] = useState(false);
  const [mostrarPreguntas, setMostrarPreguntas] = useState(false);
  const [mostrarPreguntasNegativo, setMostrarPreguntasNegativo] = useState(false);
  const [mostrarPreguntasLikes, setMostrarPreguntasLikes] = useState(false);
  const [mostrarPreguntasNegativoLikes, setMostrarPreguntasNegativoLikes] = useState(false);
  const [botonesSeleccionados, setBotonesSeleccionados] = useState([]);
  const [textoIngresado, setTextoIngresado] = useState('');
  const [otrosSeleccionado, setOtrosSeleccionado] = useState(false);
  const [textoIngresadoOtro, setTextoIngresadoOtro] = useState('');
  const [apartadoMaquina, setApartadoMaquina] = useState(false);
  const [textoIngresadoComentariosMaquina, setTextoIngresadoComentariosMaquina] = useState('');
  const [esconderAlEnviar, setEsconderAlEnviar] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [pendientes, setPendientes] = useState(null);

  const tecnicoDecodificado = decodeURIComponent(tecnico);
  const tipoServicioDecodificado = decodeURIComponent(tipo_servicio);

  const enviar = async () => {
    if (enviando) return;
    setEnviando(true);
    const opciones_mejorar = botonesSeleccionados.join(', ');
    const gusto_resultado = likeSeleccionado;

    const data = {
      ticket: ticket,
      tipo_servicio: tipoServicioDecodificado,
      tecnico: tecnicoDecodificado,
      id_sql: id_sql,
      evaluacion_tecnico: valorEvaluacion,
      comentario_positivo: textoIngresado,
      opciones_mejorar: opciones_mejorar,
      otra_opcion_mejorar: textoIngresadoOtro,
      gusto_resultado: gusto_resultado,
      comentarios_maquina: textoIngresadoComentariosMaquina,
      pendiente: false
    };

    try {
      // Llamada PUT para actualizar la evaluación (comentada)
      // const response = await axios.put(
      //   `https://desarrollotecnologicoar.com/api5/encuesta/${id_sql}`, 
      //   data,
      //   { headers: { 'Content-Type': 'application/json' } }
      // );
      // console.log(response.data);

      // Llamada POST para crear el registro en encuestas_istp
      const response1 = await axios.post(
        'https://desarrollotecnologicoar.com/api5/encuestas_istp', 
        data,
        { headers: { 'Content-Type': 'application/json' } }
      );
      console.log('Datos enviados', response1.data);
      setEsconderAlEnviar(true);
      setEnviando(false);
    } catch (error) {
      console.error('Error en solicitud PUT/POST:', error);
      alert('Error en solicitud PUT/POST: ' + error);
      setEnviando(false);
    }
  };

  const enviarPendientes = async (respuestaPendientes) => {
    if (enviando) return;
    setEnviando(true);
    const opciones_mejorar = botonesSeleccionados.join(', ');
    const gusto_resultado = likeSeleccionado;

    const data = {
      ticket: ticket,
      tipo_servicio: tipoServicioDecodificado,
      tecnico: tecnicoDecodificado,
      id_sql: id_sql,
      evaluacion_tecnico: valorEvaluacion,
      comentario_positivo: textoIngresado,
      opciones_mejorar: opciones_mejorar,
      otra_opcion_mejorar: textoIngresadoOtro,
      gusto_resultado: gusto_resultado,
      comentarios_maquina: textoIngresadoComentariosMaquina,
      pendiente: respuestaPendientes
    };

    try {
      // Llamada PUT para actualizar la evaluación pendiente (comentada)
      // const response = await axios.put(
      //   `hdesarrollotecnologicoar.com/api5/reservas_istp/encuesta/${id_sql}`, 
      //   data,
      //   { headers: { 'Content-Type': 'application/json' } }
      // );
      // console.log(response.data);

      // Llamada POST a encuestas_istp
      const response1 = await axios.post(
        'https://desarrollotecnologicoar.com/api5/encuestas_istp', 
        data,
        { headers: { 'Content-Type': 'application/json' } }
      );
      console.log('Datos enviados (pendientes)', response1.data);
      setEsconderAlEnviar(true);
      setEnviando(false);
    } catch (error) {
      console.error('Error en solicitud PUT/POST:', error);
      alert('Error en solicitud PUT/POST: ' + error);
      setEnviando(false);
    }
  };

  const siguiente = () => {
    setApartadoMaquina(true);
  };

  const handleEvaluacion = (valor) => {
    setValorEvaluacion(valor);
    if (valor < 5) {
      setMostrarPreguntas(false);
      setMostrarPreguntasNegativo(true);
    } else {
      setMostrarPreguntas(true);
      setMostrarPreguntasNegativo(false);
      setOtrosSeleccionado(false);
    }
  };

  const handleLike = () => {
    setLikeSeleccionado(true);
    setDislikeSeleccionado(false);
    setMostrarPreguntasLikes(true);
    setMostrarPreguntasNegativoLikes(false);
  };

  const handleDislike = () => {
    setDislikeSeleccionado(true);
    setLikeSeleccionado(false);
    setMostrarPreguntasLikes(false);
    setMostrarPreguntasNegativoLikes(true);
  };

  const handleBotonSeleccionado = (boton) => {
    if (botonesSeleccionados.includes(boton)) {
      setBotonesSeleccionados(botonesSeleccionados.filter(item => item !== boton));
      if (boton === 'Otros / Sugerencias') {
        setOtrosSeleccionado(false);
      }
    } else {
      setBotonesSeleccionados([...botonesSeleccionados, boton]);
      if (boton === 'Otros / Sugerencias') {
        setOtrosSeleccionado(true);
      }
    }
  };

  const handleTextoIngresado = (e) => {
    const inputValue = e.target.value;
    const maxLength = 10;
    if (inputValue.length % maxLength === 0) {
      e.target.value += '\n';
    }
    setTextoIngresado(inputValue);
  };

  const handleTextoIngresadoOtro = (e) => {
    const inputValue = e.target.value;
    const maxLength = 10;
    if (inputValue.length % maxLength === 0) {
      e.target.value += '\n';
    }
    setTextoIngresadoOtro(inputValue);
  };

  const handleTextoIngresadoComentarioMaquina = (e) => {
    const inputValue = e.target.value;
    const maxLength = 10;
    if (inputValue.length % maxLength === 0) {
      e.target.value += '\n';
    }
    setTextoIngresadoComentariosMaquina(inputValue);
  };

  // Solo actualiza el estado sin enviar automáticamente
  const handlePendientes = (respuesta) => {
    setPendientes(respuesta);
  };

  return (
    <>
      <div className="container">
        <div className="modal-contenido">
          <div style={{ minWidth: "280px", maxWidth: "600px", width: "100%", margin: "auto" }}>
            <div id="column-0-0">
              <div id="module-0-0-0" style={{ color: "inherit", fontSize: "inherit", lineHeight: "inherit" }}>
                <table role="presentation" width="100%" style={{ borderSpacing: "0!important", borderCollapse: "collapse", marginTop: "20px" }}>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center" }}>
                        <img
                          alt="template-ado-red-1"
                          src={require('../img/LOGO_ASIAROBOTICA.png')}
                          style={{ maxWidth: "100%", fontSize: "16px" }}
                          width="150"
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <img
                          alt="template-ado-red-1"
                          src={require('../img/LOGO_BL.png')}
                          style={{ maxWidth: "100%", fontSize: "16px" }}
                          width="198"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {!esconderAlEnviar && (
            <>
              {!apartadoMaquina && (
                <>
                  <h2>Evaluación</h2>
                  <h3>¿Cómo fue tu experiencia con el técnico {tecnicoDecodificado}?</h3>
                  <div className="estrellas">
                    {[1, 2, 3, 4, 5].map((valor) => (
                      <span
                        key={valor}
                        className={valor <= valorEvaluacion ? "estrella-llena" : "estrella-vacia"}
                        onClick={() => handleEvaluacion(valor)}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                  {mostrarPreguntas && (
                    <div className="preguntas">
                      <h3>¿Algún comentario positivo?</h3>
                      <textarea
                        className="inputPreguntas"
                        placeholder="Escribe aquí..."
                        value={textoIngresado}
                        onChange={handleTextoIngresado}
                      />
                    </div>
                  )}
                  {mostrarPreguntasNegativo && (
                    <div className="preguntasNegativo">
                      <h3>¿En qué podemos mejorar?</h3>
                      <button
                        className={botonesSeleccionados.includes('Actitud de Servicio') ? 'botonPreguntas seleccionado' : 'botonPreguntas'}
                        onClick={() => handleBotonSeleccionado('Actitud de Servicio')}
                      >
                        Actitud de Servicio
                      </button>
                      <button
                        className={botonesSeleccionados.includes('Conocimientos') ? 'botonPreguntas seleccionado' : 'botonPreguntas'}
                        onClick={() => handleBotonSeleccionado('Conocimientos')}
                      >
                        Conocimientos
                      </button>
                      <button
                        className={botonesSeleccionados.includes('Puntualidad') ? 'botonPreguntas seleccionado' : 'botonPreguntas'}
                        onClick={() => handleBotonSeleccionado('Puntualidad')}
                      >
                        Puntualidad
                      </button>
                      <button
                        className={botonesSeleccionados.includes('Otros / Sugerencias') ? 'botonPreguntas seleccionado' : 'botonPreguntas'}
                        onClick={() => handleBotonSeleccionado('Otros / Sugerencias')}
                      >
                        Otros / Sugerencias
                      </button>
                    </div>
                  )}
                  {otrosSeleccionado && (
                    <div className="preguntas">
                      <h3>Favor de especificar, por favor</h3>
                      <textarea
                        className="inputPreguntasOtros"
                        placeholder="Escribe aquí..."
                        value={textoIngresadoOtro}
                        onChange={handleTextoIngresadoOtro}
                      />
                    </div>
                  )}
                  <div className="modal-footer">
                    <a
                      href="https://api.whatsapp.com/send/?phone=+523331010577&text=Dudas%20de%20mi%20servicio%20t%C3%A9cnico"
                      className="Ayuda"
                    >
                      ¿Necesitas ayuda?
                    </a>
                  </div>
                  <button
                    className="btn btn-dark"
                    style={{ width: '95%' }}
                    onClick={siguiente}
                    disabled={valorEvaluacion === 0}
                  >
                    Continuar
                  </button>
                </>
              )}

              {apartadoMaquina && pendientes === null && (
                <>
                  <h2>Evaluación</h2>
                  <p style={{ fontSize: "18px" }}>
                    ¿Tu máquina quedó con algún pendiente?
                  </p>
                  <div className="botones-columnas">
                    <button
                      className="botonPreguntas"
                      onClick={() => handlePendientes(true)}
                    >
                      Sí
                    </button>
                    <button
                      className="botonPreguntas"
                      onClick={() => handlePendientes(false)}
                    >
                      No
                    </button>
                  </div>
                </>
              )}

              {apartadoMaquina && pendientes === true && (
                <>
                  <h2>Evaluación</h2>
                  <p style={{ fontSize: "18px" }}>
                    Alguien se comunicará pronto con usted.
                  </p>
                  <button
                    className="btn btn-dark"
                    style={{ width: '95%' }}
                    onClick={() => enviarPendientes(true)}
                    disabled={enviando}
                  >
                    {enviando ? 'Enviando...' : 'Enviar'}
                  </button>
                </>
              )}

              {apartadoMaquina && pendientes === false && (
                <>
                  <h2>Evaluación</h2>
                  <p style={{ fontSize: "18px" }}>
                    ¿Tu equipo quedó bien?
                  </p>
                  <div className="like-dislike">
                    <img
                      src={
                        likeSeleccionado
                          ? require('../img/like_seleccionado.png')
                          : require('../img/like.png')
                      }
                      alt="Like"
                      className={likeSeleccionado ? "LIKE_SELECCIONADO" : "LIKE"}
                      onClick={handleLike}
                    />
                    <img
                      src={
                        dislikeSeleccionado
                          ? require('../img/dislike_seleccionado.png')
                          : require('../img/dislike.png')
                      }
                      alt="Dislike"
                      className={dislikeSeleccionado ? "DISLIKE_SELECCIONADO" : "DISLIKE"}
                      onClick={handleDislike}
                    />
                  </div>
                  {mostrarPreguntasNegativoLikes && (
                    <div className="preguntas">
                      <h3>¿Alguna sugerencia de mejora?</h3>
                      <textarea
                        className="inputPreguntasComentarios"
                        placeholder="Escribe aquí..."
                        value={textoIngresadoComentariosMaquina}
                        onChange={handleTextoIngresadoComentarioMaquina}
                      />
                    </div>
                  )}
                  <div className="modal-footer">
                    <a
                      href="https://api.whatsapp.com/send/?phone=+523331010577&text=Dudas%20de%20mi%20servicio%20t%C3%A9cnico"
                      className="Ayuda"
                    >
                      ¿Necesitas ayuda?
                    </a>
                  </div>
                  <button
                    className="btn btn-dark"
                    style={{ width: '95%' }}
                    onClick={enviar}
                    disabled={enviando || valorEvaluacion === 0}
                  >
                    {enviando ? 'Enviando...' : 'Enviar'}
                  </button>
                </>
              )}
            </>
          )}

          {esconderAlEnviar && (
            <>
              <h2>Evaluación</h2>
              <p style={{ fontSize: "18px" }}>
                Gracias por contestar la encuesta del servicio técnico.
              </p>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Evaluacion;
